import React, { useState } from "react";
import { Container } from "react-bootstrap";
import "../locationServe/locationserve.css";
import "../locationServe/locationmedia.css";
import { useNavigate } from "react-router-dom";
import Map from "components/shared/Map/Map";
import { useDispatch, useSelector } from "react-redux";
import StateAndCities from "./StateAndCities";
import { GET_DEFAULT_ADDRESS } from "store/Action/HomeAction";
import LottiLoader from "components/shared/Loader/LottiLoader";

const LocationServe = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //ALL SELECTORS
  const { CITIES } = useSelector((store) => ({
    CITIES: store?.HomeReducer?.cities?.data,
  }));

  //ALL STATE
  const [activeMarker, setActiveMarker] = useState(null);
  const [mapCenter, setMapCenter] = useState("null");

  const handleOnLoad = (map) => {
    const bounds = new window.google.maps.LatLngBounds();
    CITIES?.forEach(({ position }) => bounds.extend(position));
    map.fitBounds(bounds);
  };

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  const handelSelectState = (item) => {
    const data = {
      entry_street_address: "",
      address_lat: item?.lat,
      address_lng: item?.lng,
      entry_city: item?.city_name,
      entry_state: item?.state?.name || "",
    };

    if (item?.lat && item?.city_name) {
      dispatch(GET_DEFAULT_ADDRESS(data));
      navigate(`/${item?.city_name.replace(/\s+/g, '-').toLowerCase()}`);
    }
  };

  return (
    <div>
      <section className="location-sec">
        <div className="common-heading text-center">
          <h2 className="mb-4">Locations We Serve</h2>
        </div>
        <Container>
          {CITIES?.length == 0 ? (
            <LottiLoader loader={true} height={80} width={80} />
          ) : (
            <figure className="text-center">
              {/* <img src={homeMap} alt="No_Image" className="w-100" /> */}

              {CITIES?.length > 0 && (
                <Map
                  cities={CITIES}
                  handleOnLoad={handleOnLoad}
                  setActiveMarker={setActiveMarker}
                  handleActiveMarker={handleActiveMarker}
                  dispatch={dispatch}
                  // selectedAddress={selectedAddress}
                  activeMarker={activeMarker}
                  mapCenter={mapCenter}
                  setMapCenter={setMapCenter}
                  mapZoom={700}
                  height={400}
                />
              )}
            </figure>
          )}
          <StateAndCities handelSelectState={handelSelectState} />
        </Container>
      </section>
    </div>
  );
};

export default LocationServe;
